<template>
  <div>
    <v-dialog v-model="dialogForm" persistent max-width="300px">
      <v-card>
        <v-card-title>
          <span class="headline">Create a hApp</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="hApp name *" v-model="hApp.name" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>* indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogForm">Close</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'
import HAppService from '@/services/HAppService.js'

export default {
  name: 'hAppFormComponent',
  components: {},
  data () {
    return {
      usuario: {},
      isEdit: false,
      dialogForm: false,
      itemHApp: null,
      hAppService: new HAppService(),
      hApp: {
        "id": "",
        "name": "",
        "user_id": "",
        "user_email": "",
        "dimension_id": "",
        "dimension": "",
        "content": {
          "position": {
            "x": "0",
            "z": "0",
            "y": "0"
          },
          "hObjects": []
        }
      },
      resetHApp: {
        "id": "",
        "name": "",
        "user_id": "",
        "user_email": "",
        "dimension_id": "",
        "dimension": "",
        "content": {
          "position": {
            "x": "0",
            "z": "0",
            "y": "0"
          },
          "hObjects": []
        }
      }
    }
  },
  mounted: function () {
    this.getDataUser()
    this.loadEventBusOn()
  },
  methods: {
    getDataUser () {
      this.usuario = JSON.parse(
        sessionStorage.getItem('datos_usuario_autenticado')
      )
    },
    loadEventBusOn () {
      EventBus.$on('dialogFormHApp', dialogForm => {
        this.dialogForm = dialogForm
      })
      EventBus.$on('typeFormHApp', type => {
        this.isEdit = type
      })
    },
    closeDialogForm () {
      this.dialogForm = false
    },
    save () {
      if (this.isEdit) {
        this.closeDialogForm()
      } else {
        this.formatDataInHApp()
        this.hAppService.post(this.hApp).then(response => {
          this.formatDataOutHApp(response)
          this.resetForm()
          this.closeDialogForm()
        })
      }
    },
    calculatePosition () {
      this.hApp.content.position.x = Math.round(
        window.environment.localAvatar.position.x
      )
      this.hApp.content.position.z = Math.round(
        window.environment.localAvatar.position.z
      )
      this.hApp.content.position.y = Math.round(
        window.environment.localAvatar.position.y
      )
    },
    formatDataInHApp () {
      this.calculatePosition()
      this.hApp.user_email = this.usuario.correo_electronico
      this.hApp.dimension = window.dimension
      this.hApp.content = JSON.stringify(this.hApp.content)
    },
    formatDataOutHApp (response) {
      const hApp = response
      hApp.content = JSON.parse(hApp.content)
      EventBus.$emit('NewHApp', JSON.parse(JSON.stringify(hApp)))
    },
    resetForm () {
      this.hApp = { ... this.resetHApp }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HApp/Form.vue